import { render, staticRenderFns } from "./CreateFaturas.vue?vue&type=template&id=361207e4"
import script from "./CreateFaturas.vue?vue&type=script&lang=js"
export * from "./CreateFaturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports